export function checkoutPath() {
  return '/checkout';
}

export function chatCheckoutPath() {
  return '/chat_checkout';
}

export function avaCheckoutPath() {
  return '/ava_checkout';
}
